import React, { useEffect, useState } from 'react';
import csvData from '../csv/26maygazzettetable.csv';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import BedIcon from '@mui/icons-material/Bed';
import BathroomOutlinedIcon from '@mui/icons-material/BathroomOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import '../css/style.css';

function CSVReader() {
  const [tableData, setTableData] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('Gauteng');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedRow, setSelectedRow] = useState(-1);
  const [showDetails, setShowDetails] = useState(false);
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(csvData);
      const text = await response.text();

      const rows = text.split('\n');
      const rawHeadings = rows[0].split(';');
      const headings = rawHeadings.map((heading) => heading.trim());

      const data = [];
      for (let i = rows.length - 1; i > 0; i--) {
        const values = rows[i].split(';');
        const rowObject = {};
        for (let j = 0; j < headings.length; j++) {
          const value = values[j] ? values[j].replace(/\r/g, '') : '';
          rowObject[headings[j]] = value;
        }
        const date = new Date(rowObject['Date']);
        if (date < new Date()) {
          continue;
        }
        data.push(rowObject);
      }
      data.shift();
      setTableData(data);
      setShowTable(true);
    };
    fetchData();
  }, []);

  const handleProvinceChange = (event) => {
    setSelectedProvince(event.target.value);
    setSelectedArea('');
    setSelectedRow(-1);
    setShowDetails(false);
  };

  const handleAreaChange = (event) => {
    setSelectedArea(event.target.value);
    setSelectedRow(-1);
    setShowDetails(false);
  };

  const provinces = [
    'Gauteng',
    'North West',
    'Western Cape',
    'Free State',
    'KwaZulu-Natal',
    'Mpumalanga',
    'Limpopo',
    'Northern Cape',
    'Eastern Cape',
  ];

  const handleAddressClick = (index) => {
    setSelectedRow(index);
    setShowDetails(true);
  };

  const generateGoogleMapsLink = (address) => {
    const encodedAddress = encodeURIComponent(address);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  };

  return (
    <div>
      <div className="infotext">
        <label>Search by either Province or Search by where the Sheriff is located</label>
      </div>
      <div className="selectors">
        <div className="selector">
          <label htmlFor="province" className="provincelabel">
            Search by Province:
          </label>
          <Select id="province" value={selectedProvince} onChange={handleProvinceChange}>
            <MenuItem value="">All</MenuItem>
            {provinces.map((province, index) => (
              <MenuItem key={index} value={province}>
                {province}
              </MenuItem>
            ))}
          </Select>
        </div>

        <div className="selector">
          <label htmlFor="area" className="provincelabel">
            Search by sheriff:
          </label>
          <Select id="area" value={selectedArea} onChange={handleAreaChange}>
            <MenuItem value="">All Areas</MenuItem>
            {Array.from(new Set(tableData
              .filter(row => row['Province'] === selectedProvince)
              .map(row => row['Area Location'])
            )).map((area, index) => {
              const listingsCount = tableData.filter(row => row['Area Location'] === area && row['Province'] === selectedProvince).length;
              return (
                <MenuItem key={index} value={area}>
                  {area} ({listingsCount})
                </MenuItem>
              );
            })}
          </Select>
        </div>
      </div>

      {showTable && (
        <div>
          {showDetails && selectedRow !== -1 ? (
            <div>
              <IconButton className="seeallbutton" aria-label="back" onClick={() => handleAddressClick(-1)}>
                <ArrowBackIosOutlinedIcon />
                See all listings
              </IconButton>
              <div className="row-details">
                <Typography variant="h3" className="headings">
                  Details for:
                </Typography>
                <Typography variant="h4" className="headings">
                  {tableData[selectedRow]['Address of property']}
                </Typography>
                <Grid container paddingX={5} paddingY={5} spacing={5}>
                  <Grid item md={6}>
                    <Stack spacing={2}>
                      <Box className="detail-borders" sx={{ border: 1 }}>
                        <Typography className="top-element">
                          <b className="detailstitle">Plaintiff: </b>
                          {tableData[selectedRow]['Plaintiff']}
                        </Typography>
                        <Typography className="bottom-element">
                          <b className="detailstitle">Defendants: </b>
                          {tableData[selectedRow]['Defendant(s)']}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item md={6}>
                    <Stack spacing={2}>
                      <Box className="detail-borders" sx={{ border: 1 }}>
                        <Typography className="top-element">
                          <b className="detailstitle">Date of Auction: </b>
                          {tableData[selectedRow]['Date']}
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">Location of Auction: </b>
                          {tableData[selectedRow]['Location']}
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">Province: </b>
                          {tableData[selectedRow]['Province']}
                        </Typography>
                        <Typography className="bottom-element">
                          <b className="detailstitle">Area: </b>
                          {tableData[selectedRow]['Area Location']}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container paddingX={5} paddingY={5} spacing={5}>
                  <Grid item md={6}>
                    <Stack spacing={2}>
                      <Box className="detail-borders" sx={{ border: 1 }}>
                        <Typography className="top-element">
                          <b className="detailstitle">Attorney Name: </b>
                          {tableData[selectedRow]['Attorney Name']}
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">Attorney Number: </b>
                          {tableData[selectedRow]['Attorney No.']}
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">Case Number: </b>
                          {tableData[selectedRow]['Case No.']}
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">Reserve price: </b>
                          {tableData[selectedRow]['Reserve Price']}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item md={6}>
                    <Stack spacing={2}>
                      <Box className="detail-borders" sx={{ border: 1 }}>
                        <Typography className="top-element">
                          <BedIcon className="iconpadding" />
                          <b className="detailstitle">Bedrooms: </b>
                          {tableData[selectedRow]['Bedroom']}
                        </Typography>
                        <Typography className="top-element">
                          <BathroomOutlinedIcon className="iconpadding" />
                          <b className="detailstitle">Bathrooms: </b>
                          {tableData[selectedRow]['Bathroom']}
                        </Typography>
                        <Typography className="top-element">
                          <LocationOnOutlinedIcon className="iconpadding" />
                          <a
                            href={generateGoogleMapsLink(tableData[selectedRow]['Address of property'])}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open in Google Maps
                          </a>
                        </Typography>
                        <Typography className="top-element">
                          <b className="detailstitle">ERF: </b>
                          {tableData[selectedRow]['ERF']}
                        </Typography>
                        <Typography className="bottom-element">
                          <b className="detailstitle">Size in m<sup>2</sup>:</b>{' '}
                          {tableData[selectedRow]['size (m2)']}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </div>
          ) : (
            <div>
              {tableData.length > 0 && (
                <table>
                  <tbody>
                    {tableData.map((row, index) => {
                      if (selectedArea && row['Area Location'] !== selectedArea) {
                        return null;
                      }
                      if (selectedProvince && row['Province'] !== selectedProvince) {
                        return null;
                      }

                      return (
                        <tr
                          key={index}
                          onClick={() => handleAddressClick(index)}
                          className={selectedRow === index ? 'selected' : ''}
                        >
                          <td>
                            <ArrowForwardIosOutlinedIcon className="iconpaddingmain" />
                            {row['Address of property']}
                          </td>
                        </tr>
                      );
                    }).filter(Boolean)}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CSVReader;